const formSelectWithToolTip = () => {
	const selectElement = document.querySelector('.js-select-od');
	const formId = document.querySelector('#enterDeliveryAddress');
	const checkBox = document.querySelector('#sameAsAddressCheckBox');

	if (!selectElement) {
		return;
	}

	if (checkBox) {
		checkBox.addEventListener('click', function () {
			setTimeout(() => {
				if (formId && formId.classList.contains('d-none')) {
					selectElement.removeAttribute('required');
				} else {
					selectElement.setAttribute('required', 'true');
				}
			}, 0);
		});
	} else {
		selectElement.setAttribute('required', 'true');
	}

	selectElement.addEventListener('focus', function () {
		selectElement.blur();
		this.removeAttribute('required');
	});

	selectElement.addEventListener('change', function () {
		selectElement.focus();
	});
};

export { formSelectWithToolTip };
